import React from 'react';

import { EmptyState } from 'components/TeamsCommunities/EmptyState';
import puzzlePiece from 'assets/puzzle-piece.avif';

export function TeamsDisabledState(): JSX.Element {
  const description = `Coming Soon!`;
  // const description = `👋 Teams aren't enabled on your account (yet). Teams are flexible groups for collaboration, side projects, or informal networks across your company. 👉 Want to create a Team? Reach out to your admin or your Partner Success Manager to turn this on.`;

  return <EmptyState title="Teams" description={description} illustration={puzzlePiece} />;
}
